import { getFilterControlButtonContainer, getJobTitleSearchDiv, getMultiSelectFilters } from "../listHeader";
import { JobPostingState } from "../types";

export default function setup(dataSource: JobPostingState): () => JSX.Element
{
    const getContents = function (): JSX.Element[]
    {
        let contents: JSX.Element[] = [];

        contents.push(getJobTitleSearchDiv(dataSource, "jobPostingFilterDiv jobPostingFilterInline", "jobPostingSearch__container"));
        contents.push(...getMultiSelectFilters(dataSource, "jobPostingFilterDiv", "jobPostingFilterControl jobPostingFilterInline"));
        contents.push(getFilterControlButtonContainer(dataSource, { "jobPostingFilterControlButton": true }));

        return contents;
    }

    return () => (<div>{getContents()}</div>);
}
